/* import __COLOCATED_TEMPLATE__ from './pix-pagination.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { formatMessage } from '../translations';
const DEFAULT_PAGE_OPTIONS = [{
  label: '10',
  value: 10
}, {
  label: '25',
  value: 25
}, {
  label: '50',
  value: 50
}, {
  label: '100',
  value: 100
}];
let PixPagination = (_class = class PixPagination extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
  }
  get isCondensed() {
    return this.args.isCondensed ? 'pix-pagination-condensed' : 'pix-pagination';
  }
  get beforeResultsPerPage() {
    return this.formatMessage('beforeResultsPerPage');
  }
  get previousPageLabel() {
    return this.formatMessage('previousPageLabel');
  }
  get nextPageLabel() {
    return this.formatMessage('nextPageLabel');
  }
  get pageNumber() {
    return this.formatMessage('pageNumber', {
      total: this.pageCount,
      current: this.currentPage
    });
  }
  get pageInfo() {
    return this.formatMessage('pageInfo', {
      total: this.resultsCount,
      start: this.firstItemPosition,
      end: this.lastItemPosition
    });
  }
  get pageOptions() {
    return this.args.pageOptions ? this.args.pageOptions : DEFAULT_PAGE_OPTIONS;
  }
  get selectPageSizeLabel() {
    return this.formatMessage('selectPageSizeLabel');
  }
  get pageResults() {
    return this.formatMessage('pageResults', {
      total: this.args.pagination.rowCount
    });
  }
  formatMessage(message, values) {
    return formatMessage(this.args.locale ?? 'fr', `pagination.${message}`, values);
  }
  get currentPage() {
    return this.args.pagination ? this.args.pagination.page : 1;
  }
  get pageCount() {
    if (!this.args.pagination) return 0;
    if (this.args.pagination.pageCount === 0) return 1;
    return this.args.pagination.pageCount;
  }
  get pageSize() {
    return this.args.pagination ? this.args.pagination.pageSize : this.pageOptions[0].value;
  }
  get isNextPageDisabled() {
    return this.currentPage === this.pageCount || this.pageCount === 0;
  }
  get nextPage() {
    return Math.min(this.currentPage + 1, this.pageCount);
  }
  get isPreviousPageDisabled() {
    return this.currentPage === 1 || this.pageCount === 0;
  }
  get previousPage() {
    return Math.max(this.currentPage - 1, 1);
  }
  get resultsCount() {
    return this.args.pagination ? this.args.pagination.rowCount : 0;
  }
  get firstItemPosition() {
    if (!this.args.pagination) return 0;
    return (this.currentPage - 1) * this.pageSize + 1;
  }
  get lastItemPosition() {
    if (!this.args.pagination) return 0;
    const {
      rowCount
    } = this.args.pagination;
    return Math.min(rowCount, this.firstItemPosition + this.pageSize - 1);
  }
  onChange() {
    if (typeof this.args.onChange !== 'function') return;
    this.args.onChange();
  }
  changePageSize(value) {
    this.router.replaceWith({
      queryParams: {
        pageSize: value,
        pageNumber: 1
      }
    });
    this.onChange();
  }
  goToNextPage() {
    this.router.replaceWith({
      queryParams: {
        pageNumber: this.nextPage
      }
    });
    this.onChange();
  }
  goToPreviousPage() {
    this.router.replaceWith({
      queryParams: {
        pageNumber: this.previousPage
      }
    });
    this.onChange();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changePageSize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changePageSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToNextPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToNextPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPreviousPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPreviousPage"), _class.prototype), _class);
export { PixPagination as default };